import React, { ReactElement } from 'react';
import { getLabelFallback } from '@utils/utils';

import Vector from '@images/svg-icons/vector.svg';

type ProcessStepTrackerProps = {
    stepNumber: number;
}

const ProcessStepTracker = (props: ProcessStepTrackerProps) : ReactElement => {

    const {
        stepNumber
    } = props;

    return(
        <ol className="process-step-tracker">
            <li className={"process-step-tracker-li" + (stepNumber === 0 ? " active" : "") + (stepNumber > 0 ? ' done' : '')}>
                <div className="process-step-tracker-li-number">{stepNumber === 0 ? 1 : <Vector />}</div>
                <span>{getLabelFallback('CHECKOUT_STEP1_LABEL')}</span>
            </li>
            <li className="process-step-tracker-li divider">&nbsp;</li>
            <li className={"process-step-tracker-li"  + (stepNumber === 1 ? " active" : "")}>
                <div className="process-step-tracker-li-number">2</div>
                <span>{getLabelFallback('CHECKOUT_STEP2_LABEL')}</span>
            </li>
            <li className="process-step-tracker-li divider">&nbsp;</li>
            <li className={"process-step-tracker-li"  + (stepNumber === 2 ? " active" : "")}>
                <div className="process-step-tracker-li-number">3</div>
                <span>{getLabelFallback('CHECKOUT_STEP3_LABEL')}</span>
            </li>
        </ol>
    );
}

export default ProcessStepTracker;